import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import LoginModal from './LoginModal';
import { User } from '../types/auth';
import { TylerState, useTylerStateUpdate } from '../utils/TylerState';
import CountrySelector from './shared/CountrySelector';

interface TopNavigationProps {
  onLogin: (user: any) => void;
  user?: User | null;
  onLogout?: () => void;
}

const TopNavigation: React.FC<TopNavigationProps> = ({ onLogin, user, onLogout }) => {
  // Subscribe to TylerState updates for reactive user changes
  useTylerStateUpdate();

  const [showLoginModal, setShowLoginModal] = useState(false);

  // Use TylerState.user as the source of truth
  const currentUser = TylerState.user;

  useEffect(() => {
    const handler = () => {
      // Only show login modal if user is not already logged in
      if (!currentUser) {
        setShowLoginModal(true);
      }
    };
    window.addEventListener('open-login-modal' as any, handler as any);
    return () => window.removeEventListener('open-login-modal' as any, handler as any);
  }, [currentUser]);

  const handleLoginClick = () => {
    setShowLoginModal(true);
  };

  const handleLoginSuccess = (user: any) => {
    onLogin(user);
    setShowLoginModal(false);
  };

  const handleLogout = () => {
    console.log('TopNavigation: Logout clicked, calling onLogout');
    if (onLogout) {
      onLogout();
    }
  };

  return (
    <nav className="top-navigation">
      <div className="nav-container">
        <div className="nav-left">
          <Link to="/" className="nav-logo">
            <img src="/logo192.png" alt="Larry's Help" className="logo-image" />
            <span className="logo-text">Larry's Help</span>
          </Link>
        </div>

        <div className="nav-center">
          <Link to="/scheduling" className="nav-link">Scheduling</Link>
          <Link to="/accounting" className="nav-link">Accounting</Link>
          <Link to="/larry-line/nhl" className="nav-link">Larry Line</Link>
        </div>

        <div className="nav-right" style={{ gap: '10px' }}>
          <CountrySelector variant="flags" />
          {currentUser ? (
            <div className="user-menu">
              <Link to="/account" className="user-link">
                <i className="fa fa-user"></i>
                <span>{currentUser.email}</span>
              </Link>
              <button onClick={handleLogout} className="logout-button">
                <i className="fa fa-sign-out-alt"></i>
                <span>Logout</span>
              </button>
            </div>
          ) : (
            <button onClick={handleLoginClick} className="login-button">
              <i className="fa fa-user"></i>
              <span>Login</span>
            </button>
          )}
        </div>
      </div>

      <LoginModal
        isOpen={showLoginModal}
        onClose={() => setShowLoginModal(false)}
        onLogin={handleLoginSuccess}
      />
    </nav>
  );
};

export default TopNavigation; 